/**
 * Format a timestamp to a short relative time string.
 * Accepts an ISO datetime string or a Unix milliseconds number.
 * Examples: "just now", "2m ago", "5h ago", "3d ago", "2w ago", "3mo ago", "2y ago"
 */
export function formatRelativeTime(isoString: string | number): string {
  const now = Date.now();
  const date = new Date(isoString).getTime();
  const diffMs = now - date;
  const diffMins = Math.floor(diffMs / 60_000);
  const diffHours = Math.floor(diffMs / 3_600_000);
  const diffDays = Math.floor(diffMs / 86_400_000);
  const diffWeeks = Math.floor(diffDays / 7);
  const diffMonths = Math.floor(diffDays / 30);
  const diffYears = Math.floor(diffDays / 365);

  if (diffMins < 1) return 'just now';
  if (diffMins < 60) return `${diffMins}m ago`;
  if (diffHours < 24) return `${diffHours}h ago`;
  if (diffDays < 7) return `${diffDays}d ago`;
  if (diffWeeks < 5) return `${diffWeeks}w ago`;
  if (diffMonths < 12) return `${diffMonths}mo ago`;
  if (diffYears >= 1) return `${diffYears}y ago`;

  return new Date(isoString).toLocaleDateString();
}
